"use strict";

var _useSupplierMetaSupplier_Supplier;
import { graphql, useFragment } from 'react-relay/hooks';
export const useSupplierMeta = ({
  supplier: supplierRef
}) => {
  const supplier = useFragment(_useSupplierMetaSupplier_Supplier !== void 0 ? _useSupplierMetaSupplier_Supplier : _useSupplierMetaSupplier_Supplier = require("../../relay/__generated__/useSupplierMetaSupplier_Supplier.graphql"), supplierRef);
  return supplier;
};